import { ColumnFiltersState, ColumnSort } from '@tanstack/table-core';
import type { MRT_PaginationState, MRT_SortingState } from 'mantine-react-table';

export interface ApiListResponse<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: {
    pageNumber: number;
    offset: number;
    pageSize: number;
    paged: boolean;
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    unpaged: boolean;
  };
  size: number;
  sort: {
    sorted: boolean;
    empty: boolean;
    unsorted: boolean;
  };
  totalElements: number;
  totalPages: number;
}

export interface ListRequestGlobalProps {
  pagination: MRT_PaginationState;
  sorting: MRT_SortingState;
  filters?: ColumnFiltersState;
  globalFilter?: string;
  includeArchived?: boolean;
  withArchive?: boolean;
  status?: string[];
}


export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}


export interface BaseInputProps {
  name: string;
  label: string;
  placeholder: string;
  withAsterisk?: boolean;
  description?: string;
  disabled?: boolean;
  rules?: any;
  filter?: any;
  style?: any;

}

export type SortingState = ColumnSort[];
export type FiltersState = ColumnFiltersState;

